/**
 * author: Soumya Shreyas
 */
import Multiselect from "multiselect-react-dropdown";
import React, { useEffect, useState } from "react";
import { Breadcrumb, Form } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { BiUser } from "react-icons/bi";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { ScaleLoader } from "react-spinners";
import { toast } from "react-toastify";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import MessageModal from "../../../components/MessageModal/MessageModal";
import { IncidentPriority, LOADER_COLOR } from "../../../core/constants/common";
import CompanyDashboardService from "../../../core/service/CompanyDashboardService";
import IncidentReportService from "../../../core/service/IncidentReportService";
import ProfileSettingsService from "../../../core/service/ProfileSettingsService";
import SupplierService from "../../../core/service/SupplierService";
import Utils from "../../../core/utilities/Utils";
function IncidentReporting({ t }) {
  const { paramObj } = useParams();
  //   let obj = Utils.decodeBase64(paramObj);
  //   let incidentId = JSON.parse(obj); // 0 for report a new incident and any numeric id for edit
  const navigate = useNavigate();
  //const [pageStatus, setPageStatus] = useState(incidentId>0 ? "Edit" : "Create");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [incidentTypes, setIncidentTypes] = useState([]);
  const [selIncidentType, setSelIncidentType] = useState("");
  const [selReporters, setSelReporters] = useState([]);
  const [confirmReport, setConfirmReport] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [selReportTo, setSelReportTo] = useState("Company");
  const [priority, setPriority] = useState(IncidentPriority.LOW);
  const [edit, setEdit] = useState([]);
  const [validated, setValidated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [color, setColor] = useState(LOADER_COLOR);
  const [reporters, setReporters] = useState([]);
  const [contact, setContact] = useState("");
  const [companyUsers, setCompanyUsers] = useState([]);
  const [assignee, setAssignee] = useState(0);
  const [assigneeName, setAssigneeName] = useState('');
  const [searchParams] = useSearchParams();

  const data = JSON.parse(localStorage.getItem("authority"));
  const company = data.profile.company.id;
  const companyName = data.profile.user.name;
  const companyEmail = data.profile.user.email;
  const editData = searchParams.get('data') ?? null;
  const editObj = editData ? Utils.decodeBase64(editData) : null;
  const incidentId = editObj ? JSON.parse(editObj)?.id : 0;
  const incidentCode = editObj ? JSON.parse(editObj)?.code : 0;
  useEffect(() => {
    getIncidentTypes();
    if (incidentId > 0) {
      getIncidentDetails(incidentId);
    } else {
      if (data.roles.includes("SUPPLIER_ADMIN")) {
        getConnections();
      } else {
        getCompanyUsers();
        getSuppliers();
      }
    }
    company && getCompanyDetails(company);
    companyName && setName(companyName);
    companyEmail && setEmail(companyEmail);
  }, []);

  const getIncidentTypes = async (e) => {
    IncidentReportService.getIncidentTypeList()
      .then((response) => {
        setIncidentTypes([...response.data]);
      })
      .catch((error) => { });
  };
  const getSuppliers = () => {
    SupplierService.listAllSuppliers(company)
      .then((response) => {
        setReporters([...response.data]);
      })
      .catch((error) => { });
  };

  //   const getPhoneCodeVal = (data) => {
  //     if (data.length > 0) {
  //       setContactCode(data[0].id);
  //     }
  //   };
  //   const getPhoneNumberVal = (data) => {
  //     setContact(data);
  //   };
  //   const getPhoneCodes = () => {
  //     UtilsService.getPhoneCodes()
  //       .then((response) => {
  //         setPhoneCode([...response.data]);
  //       })
  //       .catch((error) => {
  //         //ErrorHandlingService.handleError(error.response.status);
  //         console.log("err", error);
  //       });
  //   };
  //   const handleClose = () => setShow(false);
  //   const handleSupplierClose = () => setShowCreateSupplier(false);

  const handleCreate = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
    } else {
      var message = "";
      if (data.roles.includes("SUPPLIER_ADMIN")) {
        message =
          t("Incidenttitled.label") + t("willbesubmittedtocompany.label");
      } else if (selReportTo === "Supplier") {
        message =
          t("Incidenttitled.label") + t("willbesubmittedtosupplier.label");
      } else {
        message =
          t("Incidenttitled.label") + t("willbesubmittedtoriskmanager.label");
      }
      if (incidentId > 0) {
        handleConfirm();
      } else {
        setConfirmMessage(message);
        setConfirmReport(true);
      }
    }
    setValidated(true);
  };
  const handleConfirm = (e) => {
    // setShowCreateSupplier(false);
    // if (pageStatus === "Edit") {
    //   var incidentDetails = {
    //     subject: subject,
    //     incidentType: {
    //       id: selIncidentType,
    //     },
    //     reportedBy: {
    //       name: name,
    //       email: email,
    //       phoneNumber: phone,
    //     },
    //   };

    //   // updateCompany(params, invitationId);
    // } else {
    setLoading(true);
    let incidentDetails = {
      title: title,
      description: description,
      incidentType: {
        id: selIncidentType,
      },
      reportedBy: {
        name: name,
        email: email,
        phoneNumber: phone,
      },
      priority: priority
    };
    if (selReportTo === "Supplier" || data.roles.includes("SUPPLIER_ADMIN")) {
      const owners = [];
      selReporters.forEach(r => {
        if (r.companyId > 0) {
          owners.push({ id: r.companyId });
        }
      });
      incidentDetails.owners = owners;
    } else if (assignee > 0) {
      incidentDetails.assignee = { id: assignee };
    }
    if (incidentId > 0) {
      delete incidentDetails.reportedBy;
      delete incidentDetails.owners;
      delete incidentDetails.assignee;
      incidentDetails.id = incidentId;
      IncidentReportService.updateincident(incidentId, incidentDetails)
        .then(res => {
          if (res.status === 200) {
            toast.success(t("IncidentUpdated.label"), {
              position: toast.POSITION.TOP_RIGHT,
            });
            navigate("/company_admin/incident_list");
          }
        })
        .catch((error) => { })
        .finally(() => {
          setLoading(false);
        });
    } else {
      IncidentReportService.reportIncident(incidentDetails)
        .then((response) => {
          if (response.status === 201) {
            toast.success("Success", {
              position: toast.POSITION.TOP_RIGHT,
            });
            var message = t("Incidenttitled.label");
            if (data.roles.includes("SUPPLIER_ADMIN")) {
              message = message + t("hassubmittedCompany.label");
            } else if (selReportTo === "Supplier") {
              message = message + t("hassubmittedSupplier.label");
            } else {
              message = message + t("hassubmitted.label");
            }
            message = message =
              message +
              t("Pleaseuseincident.label") +
              " " +
              response?.data?.code +
              " " +
              t("forfutureref.label");
            setModalMessage(message);
            setShowMessageModal(true);
          }
        })
        .catch((error) => { })
        .finally(() => {
          setLoading(false);
        });
    }
    // }
  };

  const onSelectItems = (selectedList, selectedItem) => {
    let mulObjArr = [];
    if (selectedItem.companyId === -2) {
      const onboardedReporters = reporters?.filter(r => r.invitationStatus === "ONBOARDED") || [];
      if (selectedList.length > onboardedReporters.length) {
        // Unselect all
        // Here the dropdown options are not refreshed when the selected options are reset to empty.
        // Therefore, as a workaround, it is given a dummy single object reset first and then emptied later.
        mulObjArr = [{ companyId: 0, legalName: '' }];
        setTimeout(() => {
          // After a delay, it is set to empty
          setSelReporters([]);
        });
      } else {
        onboardedReporters.forEach(r => {
          mulObjArr.push({
            companyId: +r.companyId,
            legalName: r.legalName
          });
        });
      }
    } else {
      for (let i = 0; i < selectedList.length; i++) {
        if (selectedList[i].companyId !== -2) {
          const objId = {
            companyId: parseInt(selectedList[i].companyId),
            legalName: selectedList[i].legalName
          };
          mulObjArr.push(objId);
        }
      }
    }
    setSelReporters(mulObjArr);
  };
  const callbackConfirmModal = (boolVal) => {
    setConfirmReport(false);
    if (boolVal) {
      handleConfirm();
    }
  };
  const callbackMessageModal = (boolVal) => {
    setShowMessageModal(false);
    if (boolVal) {
      navigate("/company_admin/incident_list");
    }
  };
  const getIncidentDetails = (id) => {
    IncidentReportService.getIncidentDetails(id)
      .then((response) => {
        let res = response?.data;
        setEdit(res);
        setName(res?.reportedBy?.name);
        setEmail(res?.reportedBy?.email);
        setPhone(res?.reportedBy?.phoneNumber);
        setTitle(res?.title);
        setDescription(res?.description);
        setSelIncidentType(res?.incidentType?.id);
        setPriority(IncidentPriority[`${res?.priority}`]);
        setAssigneeName(res?.assignee?.fullName);
      })
      .catch((error) => { });
  };
  //   var title;
  //   pageStatus === "Edit"
  //     ? (title = t("ReportIncident.label"))
  //     : (title = t("ReportIncident.label"));
  const getConnections = () => {
    SupplierService.companyConnections(company)
      .then((response) => {
        setReporters([...response.data]);
      })
      .catch((error) => {
        //ErrorHandlingService.handleError(error.response.status);
      });
  };
  const getCompanyDetails = async (companyId) => {
    ProfileSettingsService.getCompanyDetails(companyId)
      .then((response) => {
        let data = response.data;
        let code = data?.primaryContact?.contactNumber?.code?.phoneCode;
        let number = data?.primaryContact?.contactNumber?.number;
        let contact = code + number;
        setPhone(contact);
      })
      .catch((error) => {
        //  console.log("err", error);
      });
  };

  /**
   * Gets the users for the company
   */
  const getCompanyUsers = () => {
    CompanyDashboardService.getUsers("")
      .then((response) => {
        setCompanyUsers([...response.data]);
      }).catch((error) => {
      });
  }

  const getReporterDropDownOptions = () => {
    const onboardedReporters = reporters?.filter(r => r.invitationStatus === "ONBOARDED") || [];
    if (selReporters.length >= onboardedReporters.length) {
      return [
        { companyId: -2, legalName: 'Remove All' },
        ...onboardedReporters
      ];
    } else {
      return [
        { companyId: -2, legalName: 'Select All' },
        ...onboardedReporters
      ];
    }
  };

  return (
    <>
      {loading && (
        
        <div className="loader-custom">
          <ScaleLoader color={color} loading={true} size={25} />
        </div>
      )}
      <section>
        <div className="Main_body">
          <div className="Company_formBox col-lg-6">
            <div className="List_header">
              <Breadcrumb className="h5">
                <Breadcrumb.Item onClick={() => { navigate(`/company_admin/incident_list`); }}> {t("Incidents.label")}</Breadcrumb.Item>
                <Breadcrumb.Item active> {incidentId > 0 ? t("EditIncident.label") + ` ${incidentCode}` : t("ReportIncident.label")}</Breadcrumb.Item>
              </Breadcrumb>
            </div>

            <Form noValidate validated={validated} onSubmit={handleCreate}>
              {/* <form onSubmit={handleCreate}> */}
              <div className="row mx-0 ReportIncident_card">
                <div className="col-lg-12 px-0">
                  <h6 className="m-0"> {t("ReporterDetails.label")}</h6>
                </div>
                <div className="col-lg-12 px-0 py-2">
                  <label  className="mb-1">{t("Name.label")} *</label>
                  <input
                    type="text"
                    className="form-control"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                    disabled={incidentId > 0}
                  />
                </div>
                <div className="col-lg-12 px-0 py-2">
                  <label  className="mb-1">{t("Emailid.label")} *</label>
                  <input
                    type="email"
                    className="form-control"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    disabled={incidentId > 0}
                  />
                </div>
                <div className="col-lg-12 px-0 py-2">
                  <label  className="mb-1">
                    {t("PhoneNumber.label")} *
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    // value={phone}
                    defaultValue={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    required
                    disabled={incidentId > 0}
                  />
                </div>

                <div className="col-lg-12 px-0 py-2">
                  <h6 className="m-0"> {t("IncidentDetails.label")}</h6>
                </div>
                <div className="col-lg-12 px-0 py-2">
                  <label  className="mb-1">
                    {t("Title.label")} *
                  </label>
                  <input
                    type="text"
                    maxLength={1000}
                    className="form-control"
                    defaultValue={title}
                    onChange={(e) => setTitle(e.target.value)}
                    required
                  />
                </div>
                <div className="col-lg-12 px-0 py-2">
                  <label  className="mb-1">
                    {t("Description.label")} *
                  </label>
                  <textarea
                    className="form-control"
                    maxLength={4000}
                    required
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  ></textarea>
                </div>
                <div className="col-lg-12 px-0 py-2">
                  <label  className="mb-1">
                    {t("IncidentType.label")} *
                  </label>
                  <select
                    className="form-select"
                    value={selIncidentType}
                    onChange={(e) => setSelIncidentType(e.target.value)}
                    required
                  >
                    <option value="" disabled hidden>
                      {t("Select.label")}
                    </option>
                    {incidentTypes?.map((type) => (
                      <option value={type.id} key={type.id}>
                        {type.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-lg-12 px-0 py-2">
                  <label className="mb-1">{t("Priority.label")}</label>
                  <select
                    className="form-select"
                    value={priority}
                    onChange={(e) => setPriority(+e.target.value)}>
                    <option value="" disabled hidden>{t("Select.label")}</option>
                    <option value={IncidentPriority.LOW} key={IncidentPriority.LOW}>
                      {Utils.getIncidentPriorityText(IncidentPriority.LOW)}
                    </option>
                    <option value={IncidentPriority.MEDIUM} key={IncidentPriority.MEDIUM}>
                      {Utils.getIncidentPriorityText(IncidentPriority.MEDIUM)}
                    </option>
                    <option value={IncidentPriority.HIGH} key={IncidentPriority.HIGH}>
                      {Utils.getIncidentPriorityText(IncidentPriority.HIGH)}
                    </option>
                  </select>
                </div>
                {
                  incidentId > 0
                    ?
                    <div className="col-lg-12 px-0 py-2">
                      <label  className="mb-1">
                        {t("Assignee.label")}
                      </label>
                      <div>
                        <div className="border rounded p-2"> <h6 className="m-0"><BiUser /> {assigneeName}</h6></div>
                      </div>
                    </div>
                    :
                    <div className="col-lg-12 px-0 py-2">
                      <label  className="mb-1">
                        {t("ReportIncidentTo.label")} *
                      </label>
                      {!data.roles.includes("SUPPLIER_ADMIN") && (
                        <div>
                          <Form.Check
                            inline
                            label={t("MyCompany.label")}
                            name="reportTo"
                            type="radio"
                            id="inline-1"
                            required
                            value="Company"
                            checked={selReportTo === "Company"}
                            onChange={(e) => { setSelReportTo(e.target.value); setSelReporters([]); }}
                          />
                          <Form.Check
                            inline
                            label={t("Supplier.label")}
                            name="reportTo"
                            type="radio"
                            id="inline-2"
                            required
                            value="Supplier"
                            checked={selReportTo === "Supplier"}
                            onChange={(e) => { setSelReportTo(e.target.value); setAssignee(0); }}
                          />
                        </div>
                      )}
                      {(selReportTo === "Supplier" ||
                        data.roles.includes("SUPPLIER_ADMIN")) && (
                          <div className="col-lg-12">
                            <Multiselect
                              options={getReporterDropDownOptions()}
                              onSelect={onSelectItems}
                              onRemove={onSelectItems}
                              displayValue="legalName"
                              selectedValues={selReporters}
                              placeholder=""
                              required
                              avoidHighlightFirstOption={true}
                            // required =  {(selReportTo === "Supplier" ||
                            // data.roles.includes("SUPPLIER_ADMIN")) ? true : false}
                            />
                          </div>
                        )}
                      {
                        selReportTo === "Company" && !data.roles.includes("SUPPLIER_ADMIN") &&
                        <div className="col-lg-12">
                          <Form.Select
                            required
                            onChange={(e) => setAssignee(+e.target.value)}>
                            <option value={0}>Select</option>
                            {
                              companyUsers.map((user, index) => {
                                return <option value={user.id} key={index}>{user.name}</option>
                              })
                            }
                          </Form.Select>
                        </div>
                      }
                    </div>
                }

                <div className="col-lg-12 px-0 py-2 text-center">
                  <button
                    type="submit"
                    className="btn btn-secondary me-2"
                    onClick={() => {
                      navigate(`/company_admin/incident_list`);
                    }}
                  >
                    {t("Cancel.label")}
                  </button>

                  <button type="submit" className="btn  btn-primary px-3">
                    {t("Submit.label")}
                  </button>
                </div>
              </div>

            </Form>
          </div>
        </div>
        {confirmReport && (
          <ConfirmationModal
            modalShow={true}
            messageText={confirmMessage}
            callbackModal={callbackConfirmModal}
            id=""
            title={t("ConfirmSubmission.label")}
          />
        )}
        {showMessageModal && (
          <MessageModal
            modalShow={true}
            messageText={modalMessage}
            callbackModal={callbackMessageModal}
            id=""
            title={t("IncidentReported.label")}
          />
        )}
      </section>
    </>
  );
}

export default withTranslation()(IncidentReporting);
